import { GlobeAltIcon } from "@heroicons/react/24/outline";
import React from "react";
import { displayableUri, sanitizeUri } from "util/uri";
import {
    ContactValueLabel,
    ContactValueRow,
    contactValueLinkClasses,
    stopClickPropagation,
} from "./display-row";

interface WebsiteDisplayProps {
    value: string;
    label: string | null;
}

export const WebsiteDisplay: React.FC<WebsiteDisplayProps> = props => {
    const { value, label } = props;

    if (!value) {
        return null;
    }

    return (
        <ContactValueRow Icon={GlobeAltIcon}>
            <a
                href={sanitizeUri(value)}
                target="_blank"
                rel="noreferrer"
                title="Open website"
                onClick={stopClickPropagation}
                className={contactValueLinkClasses}>
                {displayableUri(value, 48)}
            </a>
            <ContactValueLabel label={label} />
        </ContactValueRow>
    );
};
